// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hedge = defineModel({
  id: "hedge",
  batchId: "future",
  name: "Hedge",
  tags: ["scenery","hedge","low-poly","age-of-mcp","future"],
  summary: "A clipped hedge — a green divider and ornamental border.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.34, 0.34), color: "#46773a", position: [0, 0.17, 0] },
      { geometry: new THREE.BoxGeometry(1.02, 0.08, 0.36), color: "#37602e", position: [0, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.96, 0.1, 0.3), color: "#568a46", position: [0, 0.34, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#568a46", position: [-0.4, 0.36, -0.06], scale: [1.2, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#46773a", position: [-0.2, 0.36, 0.06], scale: [1.2, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#568a46", position: [0, 0.36, -0.06], scale: [1.2, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#46773a", position: [0.2, 0.36, 0.06], scale: [1.2, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#568a46", position: [0.4, 0.36, -0.06], scale: [1.2, 0.7, 1] },
    ],
  animations: [],
});
